import { motion } from "framer-motion";
import { IMAGES } from "../../data";

const items = [
  { img: IMAGES.showcaseSilver, label: "Studio Finish", cls: "md:col-span-8 h-[42vh] md:h-[60vh]" },
  { img: IMAGES.heroFloat, label: "Paint Correction", cls: "md:col-span-4 h-[42vh] md:h-[60vh]" },
  { img: IMAGES.showcaseFoam, label: "Foam Bath", cls: "md:col-span-5 h-[42vh] md:h-[50vh]" },
  { img: IMAGES.detailing, label: "Wheel Detail", cls: "md:col-span-7 h-[42vh] md:h-[50vh]" },
];

export const Showcase = () => {
  return (
    <section
      id="work"
      data-testid="showcase"
      className="mx-auto max-w-[1500px] px-6 py-24 md:px-12 md:py-32"
    >
      <div className="mb-14 flex items-end justify-between">
        <h2 className="font-display text-4xl font-bold uppercase tracking-tight text-white md:text-6xl">
          The <span className="text-stroke">Gallery</span>
        </h2>
        <span className="hidden font-mono text-xs uppercase tracking-[0.3em] text-white/40 md:block">
          / selected details
        </span>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
        {items.map((it, i) => (
          <motion.figure
            key={i}
            data-cursor
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ delay: (i % 2) * 0.1, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className={`group relative overflow-hidden ${it.cls}`}
          >
            <img
              src={it.img}
              alt={it.label}
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-70 transition-opacity duration-300 group-hover:opacity-90" />
            <figcaption className="absolute bottom-5 left-5 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-white">
              <span className="h-1.5 w-1.5 rounded-full bg-[var(--volt)]" />
              {it.label}
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
};
